import { Permissions } from '~/core/shared/generated/Permissions';
import { constructAuthenticatedRoute } from '~/core/shared/utils/routing';

export const MIDDLE_OFFICE_ADMIN_BASE_URL = '/admin';
export const MIDDLE_OFFICE_SETTINGS_BASE_URL = `${MIDDLE_OFFICE_ADMIN_BASE_URL}/settings`;

// Admin routes carry a `permission`, enforced by AuthenticatedRouteBoundary
// (client-side UX; the backend remains the real enforcement). Keep these in
// step with the settings navigation entries.
export const MIDDLE_OFFICE_SETTINGS_ROUTES = {
  settings: constructAuthenticatedRoute(
    MIDDLE_OFFICE_SETTINGS_BASE_URL,
    'Settings',
  ),
  settingsAccount: constructAuthenticatedRoute(
    `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/account`,
    'Account',
  ),
  settingsSecurity: constructAuthenticatedRoute(
    `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/security`,
    'Security',
  ),
  settingsSecurityTwoFactor: constructAuthenticatedRoute(
    `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/security/two-factor-authentication`,
    'Two-factor authentication',
  ),
  settingsUserManagement: {
    ...constructAuthenticatedRoute(
      `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/user-management`,
      'Users',
    ),
    permission: Permissions.UsersView,
  },
  settingsRoles: {
    ...constructAuthenticatedRoute(
      `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/roles`,
      'Roles',
    ),
    permission: Permissions.RolesView,
  },
  settingsPermissionMatrix: {
    ...constructAuthenticatedRoute(
      `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/permission-matrix`,
      'Permission Matrix',
    ),
    permission: Permissions.PermissionMatrixView,
  },
  settingsOrgManagement: {
    ...constructAuthenticatedRoute(
      `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/organisation-management`,
      'Organisations',
    ),
    permission: Permissions.OrganisationsView,
  },
  settingsBrokerManagement: {
    ...constructAuthenticatedRoute(
      `${MIDDLE_OFFICE_SETTINGS_BASE_URL}/broker-management`,
      'Brokers',
    ),
    permission: Permissions.BrokersView,
  },
} as const;
